import request from '@/utils/request2'


//通用查询的订单
export function reportTotalList(data) {
    return request({
        url:  `/cow/subject/report_total_list`,
        method: 'post',
        data: data
    })
}

//查看订单详情
export function reportPerson(data) {
    return request({
        url:  `/cow/subject/report-person?limit=${data.limit}&page=${data.page}&openId=${data.openId}&flag=${data.flag}&startDate=${data.startDate}&endDate=${data.endDate}`,
        method: 'get',
    })
}
